import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch, RootState, Notification } from 'interfaces';

import { SIDE_PANEL_ID } from 'constant';

import ModalConfirm from 'components/ui/ConfirmModal';
import Notifications from 'components/ui/Notifications';

import DetailsPanel from 'components/DetailsPanel';
import Layout from 'components/Layout';
import ScenarioManagerComponent from 'components/ScenarioManager';

import { getScenarios, deleteScenario, resetRefresh } from './scenarioManagerSlice';

const ScenarioManager = (): JSX.Element => {
  const history = useHistory();

  const dispatch = useDispatch<AppDispatch>();

  const [selectedRow, setSelectedRow] = useState({});
  const [deleteId, setDeleteId] = useState<number | null>(null);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [sidebarChangedCounter, setSidebarChangedCounter] = useState(0);

  const notificationMsg = useSelector((state: RootState) => state.scenarioManager.notification);
  const refreshList = useSelector((state: RootState) => state.scenarioManager.refreshList);

  useEffect(() => {
    // @ts-ignore
    dispatch(getScenarios());
    dispatch(resetRefresh());
  }, [dispatch, refreshList]);

  const scenarios = useSelector((state: RootState) => state.scenarioManager.scenarios);

  const [notification, setNotification] = useState<Notification>(notificationMsg);

  return (
    <Layout
      withSidePanel
      sidePanelId={SIDE_PANEL_ID}
      sidePanelElement={() => (
        <DetailsPanel
          type="scenario"
          data={{
            ...selectedRow,
            subscription: 'Subscriptions'
          }}
          withHideButton
          onButtonClick={() => {
            setSidebarChangedCounter(sidebarChangedCounter + 1);
          }}
        />
      )}
      sidebarChangedCounter={sidebarChangedCounter}
      withPageButtons={false}
    >
      <ScenarioManagerComponent
        scenarios={scenarios}
        onDelete={(id: number) => {
          setDeleteId(id);
          setShowDeleteConfirmModal(true);
        }}
        onEdit={(id: number) => {
          history?.push(`/edit-scenario/${id}`);
        }}
        onView={(id: number) => {
          history?.push(`/scenario-view/${id}`);
        }}
        setSelectedRow={setSelectedRow}
      />
      {
        showDeleteConfirmModal ? (
          <ModalConfirm
            title="Confirm delete"
            open={showDeleteConfirmModal}
            onClose={() => setShowDeleteConfirmModal(false)}
            onConfirm={() => {
              setShowDeleteConfirmModal(false);
              // @ts-ignore
              dispatch(deleteScenario({ scenarioId: deleteId }));

              setDeleteId(null);
              setSelectedRow({});
            }}
            onCancel={() => setShowDeleteConfirmModal(false)}
          >
            <p>Are you sure, you want to delete this scenario?</p>
            <p>You will not be able to recover it.</p>
          </ModalConfirm>
        ) : null
      }
      {
        notification.message && notification.open ? (
          <Notifications
            notification={notification}
            setNotification={setNotification}
          />
        ) : null
      }
    </Layout>
  );
};

export default ScenarioManager;
